import { SPACE_TYPE_META, SPACE_TYPE_ORDER, DEFAULT_SPACE_TYPE_META } from '@/utils/spaceTypeMeta'

export default {
    methods: {
        spaceTypeMetaByKey(key) {
            return SPACE_TYPE_META[key] || DEFAULT_SPACE_TYPE_META
        },
        getSpaceTypeKey(space) {
            const sid = space?.sid?.toString()
            if (!sid) return null

            return (
                SPACE_TYPE_ORDER.find(key => {
                    const meta = this.spaceTypeMetaByKey(key)
                    const spaces = this[meta.spacesStateKey]
                    return Array.isArray(spaces) && spaces.some(item => item.sid?.toString() === sid)
                }) || null
            )
        },
        spaceTypeButtonColor(space) {
            const typeKey = this.getSpaceTypeKey(space)
            return this.spaceTypeMetaByKey(typeKey).buttonColor
        },
        spaceTypeIconColorClass(space) {
            const typeKey = this.getSpaceTypeKey(space)
            return this.spaceTypeMetaByKey(typeKey).iconColorClass
        },
        spaceTypeIcon(space) {
            const typeKey = this.getSpaceTypeKey(space)
            return this.spaceTypeMetaByKey(typeKey).icon
        },
        spaceTypeLabel(space) {
            const typeKey = this.getSpaceTypeKey(space)
            return this.spaceTypeMetaByKey(typeKey).label
        }
    }
}
